import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';

@Component({
    selector: 'delivery-request-transfer',
    templateUrl: './delivery-request-transfer.component.html',
    styleUrls: ['./delivery-request-transfer.component.scss']
})
export class DeliveryRequestTransferComponent implements OnInit, OnDestroy {

    initDate: Date;
    showAddress: boolean;

    constructor(private location: Location) { }

    ngOnInit(): void { }

    ngOnDestroy(): void { }

    back() {
        this.location.back();
    }

}
